import { segmentCount } from '@wix/motion-edm-autogen-common';
import { set, merge } from 'lodash';
import { transformations } from '../common';
var RESPONSE_OBJECT_UNCHANGED = transformations.RESPONSE_OBJECT_UNCHANGED;
var contains = function (longerPath, shorterPath) {
    return longerPath.startsWith(shorterPath) &&
        segmentCount(longerPath) === segmentCount(shorterPath) + 1;
};
var buildRequestTransformation = function (_a) {
    var _b;
    var requestMessageIdentifierPath = _a.requestMessageIdentifierPath, requestMessageOptionsPath = _a.requestMessageOptionsPath;
    var transformed = set({}, requestMessageIdentifierPath, '$[0]');
    if (requestMessageOptionsPath) {
        if (contains(requestMessageIdentifierPath, requestMessageOptionsPath)) {
            return merge(transformed, (_b = {},
                _b[requestMessageOptionsPath] = { '*': '$[1]' },
                _b));
        }
        return set(transformed, requestMessageOptionsPath, '$[1]');
    }
    return transformed;
};
var buildResponseTransformation = function () { return RESPONSE_OBJECT_UNCHANGED; };
export { buildRequestTransformation, buildResponseTransformation };
//# sourceMappingURL=delete.js.map